import { Show, useContext } from 'solid-js';
import theme from '../../../style/theme';
import { Text } from '../../../ui-components/text/text';
import { CrossIcon } from '../../icons-library/cross';
import { StyledCategoryTag, StyledCategoryTagListItem, StyledIconContainer } from './mobile-category-tag.style';
import { AppContext } from '../../../app-context-provider/app-context-provider';

type MobileCategoryTagProps = {
    onClick: (e: any) => void;
    category: string | undefined;
};
export const MobileCategoryTag = (props: MobileCategoryTagProps) => {
    const { localize } = useContext(AppContext);

    return (
        <Show when={props.category}>
            <StyledCategoryTagListItem>
                <StyledCategoryTag
                    onClick={props.onClick}
                    aria-label={localize('category', 'Category')}
                >
                    <Text color={'gray'} noBlockSpacing={true} fontSize="small">
                        {props.category}
                    </Text>
                    <StyledIconContainer>
                        <CrossIcon width={1} height={1} fill={theme.palette.gray} ariaLabel={localize('remove', 'Remove')} />
                    </StyledIconContainer>
                </StyledCategoryTag>
            </StyledCategoryTagListItem>
        </Show>
    );
};
